import { Reducer } from 'redux';

import { SessionUpdateWebHostAction } from '../../../domains/session/actions.types';
import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { Hosts } from './types';

export type SessionAction = SessionConfigureAction | SessionUpdateWebHostAction;

const initialState: Hosts = {
  broadcast: '',
  ecs: '',
  graphql: '',
  legacy: '',
  msGraph: '',
  ocv: '',
  substrate: '',
  suiteHeader: '',
  telemetry: '',
  tenor: '',
  thumbnails: '',
  translate: '',
  vivaEngage: '',
  web: '',
  designerApp: '',
};

const stateWithUpdatedWebHost = (state: Hosts, action: SessionUpdateWebHostAction) => ({
  ...state,
  web: action.payload,
});

const reducer: Reducer<Hosts, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.hosts;
    case 'SESSION.UPDATE_WEB_HOST':
      return stateWithUpdatedWebHost(state, action);
    default:
      return state;
  }
};

export default reducer;
